import React from 'react';
import { Typography } from '@mui/material';
import { TextField } from 'ui/components/TextField/TextField';
import { BarcodeElementProps } from '../../../types';

interface BarcodePropertiesProps {
  selectedElement: BarcodeElementProps;
  barcodeProps: { barcodeValue: string };
  setBarcodeProps: React.Dispatch<
    React.SetStateAction<{ barcodeValue: string }>
  >;
  updateElementProperty: (
    key: keyof BarcodeElementProps,
    value: string | number | boolean
  ) => void;
  handleKeyDown: (e: React.KeyboardEvent) => void;
}

const BarcodeProperties = ({
  selectedElement,
  barcodeProps,
  setBarcodeProps,
  updateElementProperty,
  handleKeyDown,
}: BarcodePropertiesProps) => {
  const handleBarcodeValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setBarcodeProps((prev) => ({ ...prev, barcodeValue: newValue }));
    updateElementProperty('barcodeValue', newValue);
  };
  return (
    <>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Barcode Properties
      </Typography>
      {!selectedElement.dynamicField && (
        <TextField
          className="redesign"
          variant="standard"
          type="text"
          placeholder="Barcode / UPC"
          label="Barcode / UPC"
          autoComplete="nope"
          name="barcodeValue"
          value={barcodeProps.barcodeValue}
          onChange={handleBarcodeValueChange}
          onKeyDown={handleKeyDown}
        />
      )}
    </>
  );
};

export default BarcodeProperties;
